import React from 'react';

const TreatmentsSection = () => {
  return (
    <section className="relative py-16 lg:py-20">
      {/* Background Image */}
      <div
  className="absolute inset-0 z-0"
  style={{
    backgroundImage: 'url(/images/servicePage/group_Image.webp)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }}
>
  {/* Darker overlay - increased from 40% to 60% */}
  <div className="absolute inset-0"></div>
</div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          
         {/* Left Column - Title */}
<div className="flex items-center justify-center lg:justify-end">
  <h2
    className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center lg:text-right"
    style={{
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: '#C7A064',
      lineHeight: '1.2'
    }}
  >
    DEEP CARE<br />
    TREATMENTS
  </h2>
</div>
          {/* Right Column - Services */}
          <div className="space-y-8">
            {/* Luxury Conditioning Treatment */}
            <div className="space-y-8">
  {/* Luxury Conditioning Treatment */}
  <div>
    <div className="flex items-center mb-2">
      <h3 className="text-white font-semibold text-base uppercase text-left" style={{
        fontFamily: 'Montserrat, sans-serif',
        letterSpacing: '0.05em'
      }}>
        LUXURY CONDITIONING TREATMENTS
      </h3>
      <div className="flex-1 mx-3 h-[1px]" style={{ backgroundColor: '#969696' }}></div>
      <span className="text-white text-sm whitespace-nowrap"     style={{ color: '#C7A064', fontFamily: 'Montserrat, sans-serif' }}>$85-100</span>
    </div>
    <p className="text-left mb-2" style={{
      fontFamily: 'Montserrat, sans-serif',
      letterSpacing: '0.03em',
      color: '#C7A064'
    }}>
      B-3 Demi-Permanent Conditioning Treatment
    </p>
   <p className="text-white text-xs leading-relaxed text-left" style={{
      fontFamily: 'Montserrat, sans-serif'
    }}>
      An innovative, intense repair for extremely dry, chemically treated, and damaged hair. Rebuilds bonds, attracts
      and seals in moisture, and prevents moisture loss for up to 10 weeks. Also protects against heat styling. 20 min
      under the dryer.
    </p>
  </div>
</div>

            {/* Redken Acidic Bonding Treatment */}
            <div>
               <div className="flex items-center mb-2">
      <h3 className="text-white font-semibold text-base uppercase text-left" style={{
        fontFamily: 'Montserrat, sans-serif',
        letterSpacing: '0.05em'
      }}>
                  REDKEN ACIDIC BONDING INTENSE TREATMENT
                </h3>
                <div className="flex-1 mx-3 h-[1px]" style={{ backgroundColor: '#969696' }}></div>
                <span className="text-white text-sm whitespace-nowrap" style={{ color: '#C7A064', fontFamily: 'Montserrat, sans-serif' }}>$65-85</span>
              </div>
              <p className="text-white/80 text-xs leading-relaxed text-left" style={{
                fontFamily: 'Montserrat, sans-serif'
              }}>
                A customizable formula that balances moisture and protein, delivering immediate visible results. Hair becomes 
                2x stronger, 90% more conditioned, 14x smoother, and 45% less prone to breakage. Only 10 minutes!
              </p>
            </div>

            {/* Genie in a Bottle */}
            <div>
               <div className="flex items-center mb-2">
      <h3 className="text-white font-semibold text-base uppercase text-left" style={{
        fontFamily: 'Montserrat, sans-serif',
        letterSpacing: '0.05em'
      }}>
                  "GENIE IN A BOTTLE"
                </h3>
                <div className="flex-1 mx-3 h-[1px]" style={{ backgroundColor: '#969696' }}></div>
                <span className="text-white text-sm whitespace-nowrap" style={{ color: '#C7A064', fontFamily: 'Montserrat, sans-serif' }}>$30</span>
              </div>
             <p className="text-left mb-2" style={{
      fontFamily: 'Montserrat, sans-serif',
      letterSpacing: '0.03em',
      color: '#C7A064'
    }}>
                Goldwell Rich Repair / Color & Highlight Treatment
              </p>
              <p className="text-white/80 text-xs leading-relaxed text-left" style={{
                fontFamily: 'Montserrat, sans-serif'
              }}>
                This in-salon leave-in treatment deeply nourishes and hydrates damaged hair in just one minute. Leaves hair 
                softer, shinier, and stronger while repairing visible damage. Quick fix — one minute!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentsSection;